import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import instructorImage from "../../assets/Mask group.png";
import { Link } from "react-router-dom";
import { Btn, RoundedBtn } from "../../components/button.jsx/Btn";
import { Modal, InviteModal } from "../../components/modal";

export default function StudentsTable() {
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [inviteEmail, setInviteEmail] = useState("");

  const navigate = useNavigate(); // Use navigate for navigation

  const instructors = [
    {
      image: instructorImage,
      name: "James Brown",
      phoneNumber: "+234 890 8765 556",
      email: "emailaddress@gmail.com",
    },
    {
      image: instructorImage,
      name: "James Brown",
      phoneNumber: "+234 810 111 2222",
      email: "emailaddress@gmail.com",
    },
    {
      image: instructorImage,
      name: "James Brown",
      email: "emailaddress@gmail.com",
      phoneNumber: "+234 810 111 2222",
    },
    {
      image: instructorImage,
      name: "James Brown",
      email: "emailaddress@gmail.com",
      phoneNumber: "+234 810 111 2222",
    },
    {
      image: instructorImage,
      name: "James Brown",
      email: "emailaddress@gmail.com",
      phoneNumber: "+234 810 111 2222",
    },
    {
      image: instructorImage,
      name: "James Brown",
      email: "emailaddress@gmail.com",
      phoneNumber: "+234 810 111 2222",
    },
    {
      image: instructorImage,
      name: "James Brown",
      email: "emailaddress@gmail.com",
      phoneNumber: "+234 810 111 2222",
    },
    {
      image: instructorImage,
      name: "James Brown",
      email: "emailaddress@gmail.com",
      phoneNumber: "+234 810 111 2222",
    },
    {
      image: instructorImage,
      name: "James Brown",
      email: "emailaddress@gmail.com",
      phoneNumber: "+234 810 111 2222",
    },
    {
      image: instructorImage,
      name: "James Brown",
      email: "emailaddress@gmail.com",
      phoneNumber: "+234 810 111 2222",
    },
    {
      image: instructorImage,
      name: "James Brown",
      email: "emailaddress@gmail.com",
      phoneNumber: "+234 810 111 2222",
    },
    {
      image: instructorImage,
      name: "James Brown",
      email: "emailaddress@gmail.com",
      phoneNumber: "+234 810 111 2222",
    },
  ];

  const filteredInstructors = instructors.filter((instructor) =>
    instructor.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Open
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  // Open Invite Modal

  const openInviteModal = () => {
    setIsModalOpen(false);
    setIsInviteModalOpen(true);
  };

  const closeInviteModal = () => setIsInviteModalOpen(false);

  // Success Modal
  const handleInviteSubmit = (ev) => {
    ev.preventDefault();
    setIsInviteModalOpen(false);
    setIsSuccessModalOpen(true);
  };

  const viewInstructor = () => {
    navigate("/instructor/instructorPage");
  };

  return (
    <div className="p-6 bg-white">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-x-10 w-10/12">
          <h1 className="text-[#400167] font-bold text-20">All Instructors</h1>
        </div>
        <Btn onClick={openModal}>+ New Instructor</Btn>

        <Modal
          isOpen={isModalOpen}
          onClose={closeModal}
        >
          <div className="my-10">
            <h1 className="text-[#400167] text-[20px] leading-[27px] font-[700] mb-2">
              Add New Student
            </h1>
            <p className="text-[14px] leading-[18.9px] text-[#74777B]">
              You can invite a new student or add existing student
            </p>
            <div className="mt-6">
              <Link onClick={openInviteModal}>
                <div className="text-[#000000] font-satoshi underline font-[400] mb-3">
                  Invite Student
                </div>
              </Link>
              <Link>
                <div className="text-[#000000] font-satoshi underline font-[400] mb-3">
                  Add Existing Student
                </div>
              </Link>
            </div>
          </div>
        </Modal>

        {/* Invite Modal */}
        <InviteModal
          isOpen={isInviteModalOpen}
          onClose={closeInviteModal}
        >
          <div className="my-10">
            <div className="text-center">
              <h1 className="text-[#000000] text-[20px]  font-satoshi leading-[27px] font-[900] mb-2">
                Invite User to CELMA
              </h1>
              <p className="font-[500] text-[14px] text-[#0B2239] leading-[18.9px] font-satoshi">
                Login details will be sent to user
              </p>
            </div>
            <form
              className="my-12"
              onSubmit={handleInviteSubmit}
            >
              <label
                htmlFor="invite-email"
                className="block mb-2 font-[500] text-[14px] text-[#0B2239] leading-[18.9px] font-satosh"
              >
                Email Address
              </label>
              <input
                type="email"
                id="invite-email"
                value={inviteEmail}
                onChange={(ev) => setInviteEmail(ev.target.value)}
                className="w-full p-2  rounded-lg focus:outline-none border-0 bg-[#F3F5F5] py-[16px]"
              />
              <div className="mt-4 flex justify-center">
                <RoundedBtn
                  type="submit"
                  className="font-[700] font-satoshi  leading-[21.6px] w-full rounded-full text-white py-[16px] bg-[#5002D0]  h-[60px] mt-10 text-[16px] "
                >
                  <span>Invite User</span>
                </RoundedBtn>
              </div>
            </form>
          </div>
        </InviteModal>
      </div>

      <Table
        instructors={filteredInstructors}
        onviewInstructor={viewInstructor}
      />

      {/* Render modals conditionally */}
      {/* <LessonsModal
        isOpen={modalType === "Lessons"}
        onClose={closeModal}
      />
      <ExamsModal
        isOpen={modalType === "Exams"}
        onClose={closeModal}
      />
      <ClassroomsModal
        isOpen={modalType === "Classrooms"}
        onClose={closeModal}
      /> */}
    </div>
  );
}

function Table({ instructors, onviewInstructor }) {
  return (
    <table className="w-full rounded-lg shadow-lg px-2 bg-white">
      <thead>
        <tr className=" uppercase font-[600] text-sm font-Nunito">
          <th className="py-2 px-4 text-left text-[#3F3F3F] font-light">
            Student Name
          </th>
          <th className="py-2 px-4 text-left text-[#3F3F3F] font-light">
            Phone Number
          </th>
          <th className="py-2 px-4 text-left text-[#3F3F3F] font-light">
            Email Address
          </th>
          <th className="py-2 px-4 text-left text-[#3F3F3F] font-light">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        {instructors.map((instructor, index) => (
          <Instructor
            key={index}
            instructor={instructor}
            onViewInstructor={onviewInstructor}
          />
        ))}
      </tbody>

      {/* <tbody>
        {instructors.map((instructor, index)) => (
          <Instructor
            key={index}
            instructor={instructors}
            onViewInstructor={onviewInstructor} />
           
        )}

      </tbody> */}
    </table>
  );
}

function Instructor({ instructor, onViewInstructor }) {
  return (
    <tr>
      <div className=" flex px-2 text-xs  items-center">
        <img
          className=" w-6 h-6"
          src={instructor.image}
          alt="caristaImg"
        />
        <td className="py-2 font-semibold px-4 ">{instructor.name}</td>
      </div>
      <td className="py-2 px-4 text-xs ">{instructor.phoneNumber}</td>
      <td className="py-2 px-4 text-xs ">{instructor.email}</td>
      <td className="py-2 px-4 text-xs">
        <button
          onClick={onViewInstructor}
          className="bg-[#DDD3FF] text-[#5002D0] py-2 text-xs px-4 rounded-[8px] hover:bg-purple-200 "
        >
          Show details
        </button>
      </td>
    </tr>
  );
}
